module.exports = __webpack_public_path__ + "img/Arista-Networks.2b326f2.svg";